import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REWARD_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

export const fetchPOById = createAsyncThunk("fetchPOById", async (params, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`${REWARD_BASE_URL}channel/${params.channel}/po/${params.id}`);
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const RewardsPOGetByIdSlice = createSlice({
	name: "RewardsPOGetByIdSlice",
	initialState: {
		isLoading: false,
        isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPOGetByIdState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPOById.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(fetchPOById.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPOById.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPOGetByIdState } = RewardsPOGetByIdSlice.actions;
export default RewardsPOGetByIdSlice.reducer;
